import { configureStore, combineReducers } from '@reduxjs/toolkit';
import PortalSlice from './portal-slice';
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

const persistConfig = {
    key: 'root',
    storage,
}

// Define the rootReducer by combining reducers
const rootReducer: any = combineReducers({
    portal: PortalSlice.reducer,
    // Add other reducers here if you have more slices
});

// Define RootState type
export type RootState = ReturnType<typeof rootReducer>;


const persistedReducer = persistReducer(persistConfig, rootReducer)

// Create the store with the rootReducer
const portalStore = configureStore({
    reducer: persistedReducer,
    middleware: [thunk]
});

export const persistor = persistStore(portalStore)
export default portalStore;
